import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import {
  getCSSColorHoverText,
  getCSSSizeLgText,
  getCSSSizeMdText,
  getCSSSizeSmText,
} from '~/utilities/getCSS';
import { AppDataContext } from '~/contexts/AppDataContext';
import type { LinkValueInterface } from '~/types/AppData/Layout/LinkValueInterface';
import { getFontSizeObject } from '~/utilities/getFontSizeObject';

const navLink = cva('', {
  variants: {
    hoverColor: getCSSColorHoverText(),
    sizeSm: getCSSSizeSmText(),
    sizeMd: getCSSSizeMdText(),
    sizeLg: getCSSSizeLgText(),
  },
});

type NavLinkType = {
  item: LinkValueInterface;
};

export default component$(({ item }: NavLinkType): JSX.Element => {
  const appData = useContext(AppDataContext);

  return (
    <li>
      <a
        href={item.link.url}
        class={navLink({
          hoverColor: appData.themeComponents.footer.linksHoverStateColor.value,
          ...getFontSizeObject(appData.themeComponents.footer, 'linksFontSize'),
        })}
      >
        {item.link.text}
      </a>
    </li>
  );
});
